module.exports = __webpack_public_path__ + "fonts/iconfont.b868ebec.woff2";